module.exports = __webpack_public_path__ + "img/arrow-faq.c55b8339.svg";